export class PaymentClass {
    id:           number;
    reference_no: string;
    total_amount: number;
    first_name:   string;
    last_name:    string;
    email:        string;
    sday:         string;
    smonth:       string;
    syear:        string;
}
